export let names = {
  'FIRMA HANDLOWA': 'F.H.',
  'FIRMA HANDLOWO-USŁUGOWA': 'F.H.U.',
  'FIRMA USŁUGOWA': 'F.U.',
  'FIRMA USŁUGOWO-HANDLOWA': 'F.H.U.',
  'FIRMA PRODUKCYJNO-USŁUGOWO-HANDLOWA': 'F.P.U.H.',
  'FIRMA PRODUKCYJNO-HANDLOWO-USŁUGOWA': 'F.P.H.U.',
  'FIRMA USŁUGOWO HANDLOWA': 'F.H.U.',
  'FIRMA PRODUKCYJNO USŁUGOWO HANDLOWA': 'F.P.U.H.',
  'FIRMA PRODUKCYJNO HANDLOWO USŁUGOWA': 'F.P.H.U.',
  'PRZEDSIĘBIORSTWO HANDLOWE': 'P.H.',
  'PRZEDSIĘBIORSTWO HANDLOWO-USŁUGOWE': 'P.H.U.',
  'PRZEDSIĘBIORSTWO HANDLOWO-PRODUKCYJNE': 'P.H.P.',
  'PRZEDSIĘBIORSTWO HANDLOWO-USŁUGOWO-PRODUKCYJNE': 'P.H.U.P.',
  'PRZEDSIĘBIORSTWO HANDLOWO-PRODUKCYJNO-USŁUGOWE': 'P.H.P.U.',
  'PRZEDSIĘBIORSTWO PRODUKCYJNO-HANDLOWE': 'P.P.H.',
  'PRZEDSIĘBIORSTWO PRODUKCYJNO-HANDLOWO-USŁUGOWE': 'P.P.H.U.',
  'PRZEDSIĘBIORSTWO PRODUKCYJNO USŁUGOWE': 'P.P.U.',
  'PRZEDSIĘBIORSTWO PRODUKCYJNO USŁUGOWO HANDLOWE': 'P.P.U.H.',
  'PRZEDSIĘBIORSTWO HANDLOWO USŁUGOWE': 'P.H.U.',
  'PRZEDSIĘBIORSTWO HANDLOWO PRODUKCYJNE': 'P.H.P.',
  'PRZEDSIĘBIORSTWO HANDLOWO USŁUGOWO PRODUKCYJNE': 'P.H.U.P.',
  'PRZEDSIĘBIORSTWO HANDLOWO PRODUKCYJNO USŁUGOWE': 'P.H.P.U.',
  'PRZEDSIĘBIORSTWO PRODUKCYJNO HANDLOWE': 'P.P.H.',
  'PRZEDSIĘBIORSTWO PRODUKCYJNO HANDLOWO USŁUGOWE': 'P.P.H.U.',
  'PRZEDSIĘBIORSTWO USŁUGOWE': 'P.U.',
  'PRZEDSIĘBIORSTWO USŁUGOWO-HANDLOWE': 'P.U.H.',
  'PRZEDSIĘBIORSTWO USŁUGOWO-PRODUKCYJNE': 'P.U.P.',
  'PRZEDSIĘBIORSTWO USŁUGOWO-PRODUKCYJNO-HANDLOWE': 'P.U.P.H.',
  'PRZEDSIĘBIORSTWO USŁUGOWO-HANDLOWO-PRODUKCYJNE': 'P.U.H.P.',
  'PRZEDSIĘBIORSTWO USŁUGOWO HANDLOWE': 'P.U.H.',
  'PRZEDSIĘBIORSTWO USŁUGOWO PRODUKCYJNE': 'P.U.P.',
  'PRZEDSIĘBIORSTWO USŁUGOWO PRODUKCYJNO HANDLOWE': 'P.U.P.H.',
  'PRZEDSIĘBIORSTWO USŁUGOWO HANDLOWO PRODUKCYJNE': 'P.U.H.P.',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWE': 'P.W.',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWO-HANDLOWE': 'P.W.H',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWO-USŁUGOWE': 'P.W.U.',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWO-USŁUGOWO-HANDLOWE': 'P.W.U.H.',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWO-HANDLOWO-USŁUGOWE': 'P.W.H.U.',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWO HANDLOWE': 'P.W.H',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWO USŁUGOWE': 'P.W.U.',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWO USŁUGOWO HANDLOWE': 'P.W.U.H.',
  'PRZEDSIĘBIORSTWO WIELOBRANŻOWO HANDLOWO USŁUGOWE': 'P.W.H.U.',
  'SPÓŁKA AKCYJNA': 'S.A.',
  'SPÓŁKA CYWILNA': 'S.C.',
  'SPÓŁKA KOMANDYTOWO-AKCYJNA': 'SP. K.A.',
  'SPÓŁKA KOMANDYTOWO AKCYJNA': 'SP. K.A.',
  'SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ': 'Sp. z o.o.',
  'SPÓŁKA JAWNA': 'SP. J.',
  'SPÓŁKA KOMANDYTOWA': 'SP. K.',
  'SPÓŁKA PARTNERSKA': 'SP. P.',
  'ZAKŁAD PRODUKCYJNO-HANDLOWY': 'Z.P.H.',
  'ZAKŁAD PRODUKCYJNO-USŁUGOWY': 'Z.P.U.',
  'ZAKŁAD PRODUKCYJNO-HANDLOWO-USŁUGOWY': 'Z.P.H.U.',
  'ZAKŁAD PRODUKCYJNO-USŁUGOWO-HANDLOWY': 'Z.P.U.H.',
  'ZAKŁAD PRODUKCYJNO HANDLOWY': 'Z.P.H.',
  'ZAKŁAD PRODUKCYJNO USŁUGOWY': 'Z.P.U.',
  'ZAKŁAD PRODUKCYJNO HANDLOWO USŁUGOWY': 'Z.P.H.U.',
  'ZAKŁAD PRODUKCYJNO USŁUGOWO HANDLOWY': 'Z.P.U.H.',
  'ZAKŁAD USŁUGOWY': 'Z.U.',
  'Sp. Z O.o.': 'SP. Z O.O.',
  'Sp. K.A.': 'SP. K.A.',
  'F.p.u.h.': 'F.P.U.H.',
  'F.p.h.u.': 'F.P.H.U.',
  'P.h.p.u': 'P.H.P.U.',
  'P.h.u.p.': 'P.H.U.P.',
  'P.h.p.u.': 'P.H.P.U.',
  'P.p.h.u.': 'P.P.H.U.',
  'P.p.u.h.': 'P.P.U.H.',
  'P.u.p.h.': 'P.U.P.H.',
  'P.u.h.p.': 'P.U.H.P.',
  'P.w.u.h.': 'P.W.U.H.',
  'P.w.h.u.': 'P.W.H.U.',
  'Z.p.h.u.': 'Z.P.H.U.',
  'Z.p.u.h.': 'Z.P.U.H.',
  'F.h.u': 'F.H.U',
  'F.u.h.': 'F.H.U',
  'F.h.u.': 'F.H.U.',
  'P.h.u.': 'P.H.U.',
  'P.h.p.': 'P.H.P.',
  'P.p.h.': 'P.P.H.',
  'P.p.u.': 'P.P.U.',
  'P.u.h.': 'P.U.H.',
  'P.u.p.': 'P.U.P.',
  'P.w.': 'P.W.',
  'P.w.h.': 'P.W.H.',
  'P.w.u.': 'P.W.U.',
  'Sp. j.': 'SP. J.',
  'Sp. k.': 'SP. K.',
  'Sp. p.': 'SP. P.',
  'Z.p.h.': 'Z.P.H.',
  'Z.p.u.': 'Z.P.U.',
  'S.A.': 'S.A.',
  'S.C.': 'S.C.',
  'Z.u.': 'Z.U.',
  'F.h.': 'F.H.',
  'F.u.': 'F.U.',
  'P.h.': 'P.H.',
  'P.u.': 'P.U.',
};

export let addresses = {
  'Ul.': 'ul.',
  'Os.': 'os.',
  'Al.': 'al.',
  'Pl.': 'pl.',
};

export let conjunctions = {
  ' A ': ' a ',
  ' I ': ' i ',
  ' O ': ' o ',
  ' U ': ' u ',
  ' W ': ' w ',
  ' Z ': ' z ',
};
